import { Component, OnInit } from '@angular/core';
import { NotitiesCommonService } from '../notities-common.service';
import { MenuService } from '../../menu.service';
import { INotitieDb } from '../../offline/cobradb';
import { AppRoutingService } from '../../app-routing.service';
import { Observable, Subject } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { createCmdFactory } from '@cevi/rxjscommands';
import { RouterLink } from '@angular/router';
import { NgIf, NgFor, AsyncPipe, DatePipe } from '@angular/common';

interface IRecenteNotitiesVm {
  notities: INotitieDb[];
  hasMoreResults: boolean;
  page: number;
}

@Component({
    selector: 'app-recente-notities',
    templateUrl: './recente-notities.component.html',
    styleUrls: ['./recente-notities.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, RouterLink, AsyncPipe, DatePipe]
})
export class RecenteNotitiesComponent implements OnInit {

  vm$: Observable<IRecenteNotitiesVm>;
  vm: IRecenteNotitiesVm;

  notitieGelezenSubj = new Subject<INotitieDb>();
  detailPuntSubj = new Subject<INotitieDb>();
  meerNotitiesSubj = new Subject<number>();

  constructor(private notitieService: NotitiesCommonService, private menuService: MenuService, private appRouting: AppRoutingService) {

    const cmdFactory = createCmdFactory<IRecenteNotitiesVm>();
    cmdFactory.addMapAction(this.setNotitieGelezen$,'setNotitieGelezen');
    cmdFactory.addMapAction(this.getMoreNotitiesAction$,'getMoreNotities');
    this.vm$ = cmdFactory.merge(this.getInitial$());
  }

  ngOnInit() { }

  getInitial$ = () => {
    return this.notitieService.getRecenteNotities(0, true).pipe(
      map(result => ({ notities: result.items, hasMoreResults: result.hasMoreResults, page: result.page }))
    );
  }

  private getMoreNotitiesAction$ = this.meerNotitiesSubj.pipe(
    mergeMap(page => this.notitieService.getRecenteNotities(page, false)),
    map( result => (vm:IRecenteNotitiesVm)=>({ ...vm, notities: result.items, hasMoreResults: result.hasMoreResults, page: result.page }))
  )

  private setNotitieGelezen$ = this.notitieGelezenSubj.pipe(
    mergeMap(notitie => this.notitieService.setNotitieGelezen(notitie.Id).pipe(map(result => notitie))),
    map(notitie => (vm:IRecenteNotitiesVm) => {
      this.menuService.decreaseRecenteNotitiesCount();
      return { ...vm, notities: vm.notities.filter(n => n !== notitie) };
    })
  );

  getNotitieId = (_index: number, notitie: INotitieDb) => notitie.Id;

  close() {
    this.menuService.closeAllFlyouts();
  }
  navigateToAgendapunt(notitie: INotitieDb) {
    this.menuService.closeAllFlyouts();
    this.appRouting.createNavigateToDetailZittingHistoryItem(notitie.ZittingId);
    this.appRouting.navigateToDetailPunt(notitie.ZittingId, notitie.AgendapuntId, false);
  }

}
